<template>
  <div :class="[wrapperClass, { 'member-menu-open': memberMenuOpen }]">
    <div
      v-if="kyc_brand"
      class="top"
      :class="{ 'dis_none': $route.path !== '/user/KYC' && $route.path !== '/user/edit' && $route.path !== '/user/verify' }"
    >
      {{ $t('Bao.personal_info_setting') }}
    </div>
    <!-- 個人資料／KYC／安全中心：分頁與內容包在 kyc-frame 內（切版 my-KYC-v4.html） -->
    <div v-if="kyc_page && !kyc_brand" class="member-heading">
      <h1>{{ $t('Bao.verify_account') }}</h1>
    </div>
    <div v-if="kyc_page" class="kyc-frame">
      <!-- 767px 以下 kyc-tab-frame 收合，由此按鈕展開（切版 member-center.js 的 KYC 分支） -->
      <button
        v-if="!kyc_brand"
        type="button"
        class="member-menu-toggle"
        aria-controls="kyc-navigation"
        :aria-expanded="String(memberMenuOpen)"
        @click="memberMenuOpen = !memberMenuOpen"
      >
        {{ currentTabLabel }}
      </button>
      <ul
        id="kyc-navigation"
        class="kyc-tab-frame"
        :class="{ 'dis_none': kyc_brand }"
      >
        <li
          v-if="showAccountSetting"
          class="tab-items verify-items "
          :class="{ 'active': $route.path === '/user/edit' }"
          @click="$router.push('/user/edit')"
        >
          {{ $t('Bao.personal_info_setting') }}
        </li>
        <li
          v-if="permissionInfo.enable_kyc_certification !== 0"
          class="tab-items kyc-items"
          :class="{ 'active': $route.path === '/user/KYC' }"
          @click="$router.push('/user/KYC')"
        >
          {{ $t('Bao.personal_info_kyc') }}
        </li>
        <!-- 安全中心含密碼設定，不受 enable_google_totp 影響（僅 Google 二次驗證區塊受控） -->
        <li
          class="tab-items authenticator-items"
          :class="{ 'active': $route.path === '/user/verify' }"
          @click="$router.push('/user/verify')"
        >
          {{ $t("Bao.auth_page_text_1") }}
        </li>
      </ul>
      <router-view class="kyc-container" />
    </div>
    <!-- 其他會員頁：nav-tabs 與內容需為 .my-wrap 的直接子元素（切版 my.html） -->
    <template v-else>
      <!-- 1100px 以下 nav-tabs 收合，由此按鈕展開（切版 member-center.js 的 member-menu-toggle） -->
      <div class="member-heading">
        <h1>{{ currentTabLabel }}</h1>
      </div>
      <button
        type="button"
        class="member-menu-toggle"
        aria-controls="member-page-navigation"
        :aria-expanded="String(memberMenuOpen)"
        @click="memberMenuOpen = !memberMenuOpen"
      >
        {{ currentTabLabel }}
      </button>
      <ul id="member-page-navigation" class="nav-tabs ">
        <li :class="{ 'active': $route.path === '/user' }" @click="$router.push('/user')">
          <span>
            {{ $t("Bao.personal") }}
          </span>
        </li>
        <li :class="{ 'active': $route.path === '/user/bet-history' }" @click="$router.push('/user/bet-history')">
          <span>
            {{ $t("Bao.my_game_bet") }}
          </span>
        </li>
        <li :class="transactionClass" @click="$router.push('/user/transaction-history')">
          <span>
            {{ $t("Bao.transaction-index") }}
          </span>
        </li>
        <li
          v-if="themeConfig.showBankCreate && !isOfflineAgentMember"
          :class="{ active: $route.path === '/user/bank' || $route.path === '/user/bank/create' }"
          @click="$router.push('/user/bank')"
        >
          <span>{{ $t("Bao.add_bank_card") }}</span>
        </li>
        <li
          v-if="themeConfig.showUserLetter"
          :class="{ 'active': $route.path === '/user/letter' }"
          @click="$router.push('/user/letter')"
        >
          <span>
            {{ $t("Bao.announcement_letter") }}
          </span>
        </li>
        <li
          v-if="themeConfig.showNews"
          :class="{ 'active': $route.path.startsWith('/user/news') }"
          @click="$router.push('/user/news')"
        >
          <span>
            {{ $t("Bao.news") }}
          </span>
        </li>
        <!-- <li
          v-show="token && memberInfo.member_type !== 3"
          :class="{ 'active': $route.path === '/user/friend' }"
          @click="$router.push('/user/friend')"
        >
          <span>
            {{ $t("Bao.promos") }}
          </span>
        </li> -->
      </ul>
      <router-view />
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import themeMixin from '@/mixins/themeMixin'

export default {
  mixins: [themeMixin],
  data() {
    return {
      memberMenuOpen: false
    }
  },
  computed: {
    ...mapGetters(['token', 'brandInfo', 'memberInfo', 'permissionInfo', 'showAccountSetting', 'isOfflineAgentMember']),
    route() {
      return this.$route
    },
    kyc_brand() {
      return this.brandInfo.kyc_brand !== 'self'
    },
    kyc_page() {
      return this.route.path === '/user/edit' || this.route.path === '/user/KYC' || this.route.path === '/user/verify'
    },
    wrapperClass() {
      if (this.route.path === '/user/edit' && this.kyc_brand) {
        return 'my-wrap-kyc'
      } else if (this.route.path === '/user' || this.route.path === '/user/bet-history') {
        // 投注紀錄同切版 my-bet.html，外框只有 my-wrap
        return 'my-wrap'
      } else if (this.route.path !== '/user/edit' && !this.kyc_page) {
        return 'my-wrap finance-wrap'
      } else {
        return 'my-wrap my-kyc-wrap'
      }
    },
    currentTabLabel() {
      const path = this.route.path
      if (path === '/user/edit') return this.$t('Bao.personal_info_setting')
      if (path === '/user/KYC') return this.$t('Bao.personal_info_kyc')
      if (path === '/user/verify') return this.$t('Bao.auth_page_text_1')
      if (path === '/user/bank' || path === '/user/bank/create') return this.$t('Bao.add_bank_card')
      if (path === '/user/bet-history') return this.$t('Bao.my_game_bet')
      if (path === '/user/letter') return this.$t('Bao.announcement_letter')
      if (path.startsWith('/user/news')) return this.$t('Bao.news')
      if (this.transactionClass.active) return this.$t('Bao.transaction-index')
      return this.$t('Bao.personal')
    },
    transactionClass() {
      return {
        'active': this.route.path === '/user/transaction-history' ||
                  this.route.path === '/user/bonus' ||
                  this.route.path === '/user/commission' ||
                  this.route.path === '/user/deposit-record' ||
                  this.route.path === '/user/withdrawal-record'
      }
    }
  },
  watch: {
    // 切換會員頁後收起手機選單
    '$route.path'() {
      this.memberMenuOpen = false
    }
  },
  created() {
  }
}
</script>
